<template>
<div class="chapter">
<div class="inner_page">
<p class="Title-Pt">PART I</p>
<p class="Title-Pt1">FROM ARMY BRAT TO VIETNAM</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Part01.vue?95066a5c